import { selectBuildingInfoByTypeId } from "../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../utils/utilBuildings";
import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialHarvestClickAcre = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    var isCornHarvestTutorial = tutorialStepConfig.nextStep === IdTutorialStep.harvestCorn_clickAcre;
    var isWildflowersHarvestTutorial = tutorialStepConfig.nextStep === IdTutorialStep.harvestWildflowers_clickAcre;
    if (!isCornHarvestTutorial && !isWildflowersHarvestTutorial) {
        return undefined;
    }
    if (nextTutorialStepConfig.buildingId === undefined) {
        return undefined;
    }
    var hasFinishedProduction;
    var focusBuilding = selectBuildingInfoByTypeId(state, nextTutorialStepConfig.buildingId);
    if (focusBuilding) {
        hasFinishedProduction = utilBuildings.hasFinishedProduction(focusBuilding, state.productionInfo.removedProductions);
    }
    return hasFinishedProduction ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialHarvestClickAcre.ts
// module id = 905
// module chunks = 3